import { collection, doc, getDoc, getDocs, limit, orderBy, query } from "firebase/firestore";
import { Resume } from "../../models/Resume";
import { firestore } from "../../utils/firebase";
import { IResumeRepository } from "./IResumeRepository";

export class FirebaseResumeRepository extends IResumeRepository {
    getResume: () => Promise<Resume> = async () => {
        const latestResumeQuery = query(
            collection(firestore, "resume"),
            orderBy("createdAt", "desc"),
            limit(1)
        );
        const resumeQueryResult = await getDocs(latestResumeQuery);
        return (resumeQueryResult.docs[0].data() as Resume);
    }
    getResumeById: (id: string) => Promise<Resume> = async (id: string) => {
        const resumeResult = await getDoc(
            doc(collection(firestore, "resume"), id),
        );
        return resumeResult.data() as Resume;
    }
}